// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RightSidebar-module__font-s-10___DacaV {
  font-size: 10px !important;
}

.RightSidebar-module__font-s-12___EJu1q {
  font-size: 12px !important;
}

.RightSidebar-module__font-s-13___hgo1n {
  font-size: 13px !important;
}

.RightSidebar-module__font-s-14___qZdWi {
  font-size: 14px !important;
}

.RightSidebar-module__font-s-15___E4Vog {
  font-size: 15px !important;
}

.RightSidebar-module__font-s-16___zwikC {
  font-size: 16px !important;
}

.RightSidebar-module__font-s-18___EaQKp {
  font-size: 18px !important;
}

.RightSidebar-module__font-s-20___dwv6O {
  font-size: 20px !important;
}

.RightSidebar-module__font-s-22___fOIcl {
  font-size: 22px !important;
}

.RightSidebar-module__font-s-28___GI81Y {
  font-size: 28px !important;
}

.RightSidebar-module__font-w-400___c2Ybm {
  font-weight: 400 !important;
}

.RightSidebar-module__font-w-500___aJLy2 {
  font-weight: 500 !important;
}

.RightSidebar-module__font-w-600___g9Rtq {
  font-weight: 600 !important;
}

.RightSidebar-module__font-w-700___pIo6H {
  font-weight: 700 !important;
}

.RightSidebar-module__p-5___yghRX {
  padding: 5px !important;
}

.RightSidebar-module__p-12___FNMDL {
  padding: 12px !important;
}

.RightSidebar-module__p-16___OM7FV {
  padding: 16px !important;
}

.RightSidebar-module__p-30___JaZus {
  padding: 30px !important;
}

.RightSidebar-module__p-b-0___Gy96Y {
  padding-bottom: 0 !important;
}

.RightSidebar-module__p-b-5___qiRoI {
  padding-bottom: 5px !important;
}

.RightSidebar-module__p-b-10___UMEe1 {
  padding-bottom: 10px !important;
}

.RightSidebar-module__p-b-12___zmPUL {
  padding-bottom: 12px !important;
}

.RightSidebar-module__p-b-16___btmLb {
  padding-bottom: 16px !important;
}

.RightSidebar-module__p-b-18___ToNjD {
  padding-bottom: 18px !important;
}

.RightSidebar-module__p-b-20___eLEgf {
  padding-bottom: 20px !important;
}

.RightSidebar-module__p-b-25___qMU4i {
  padding-bottom: 25px !important;
}

.RightSidebar-module__p-b-30___dUxkr {
  padding-bottom: 30px !important;
}

.RightSidebar-module__p-b-50___FhwTE {
  padding-bottom: 50px !important;
}

.RightSidebar-module__p-t-0___nWTke {
  padding-top: 0 !important;
}

.RightSidebar-module__p-t-12___w8ew5 {
  padding-top: 12px !important;
}

.RightSidebar-module__p-t-16___bO9vh {
  padding-top: 16px !important;
}

.RightSidebar-module__p-t-18___s1Ies {
  padding-top: 18px !important;
}

.RightSidebar-module__p-t-20___nMFus {
  padding-top: 20px !important;
}

.RightSidebar-module__p-t-30___QuvuJ {
  padding-top: 30px !important;
}

.RightSidebar-module__p-t-40___pV5_a {
  padding-top: 40px !important;
}

.RightSidebar-module__p-t-50____HqPD {
  padding-top: 50px !important;
}

.RightSidebar-module__p-l-20___rIeXr {
  padding-left: 20px !important;
}

.RightSidebar-module__p-l-30___eD78m {
  padding-left: 30px !important;
}

.RightSidebar-module__p-l-40___nH7di {
  padding-left: 40px !important;
}

.RightSidebar-module__p-r-16___cvgy8 {
  padding-right: 16px !important;
}

.RightSidebar-module__p-r-20___MMrN4 {
  padding-right: 20px !important;
}

.RightSidebar-module__p-r-30___cxxB9 {
  padding-right: 30px !important;
}

.RightSidebar-module__p-r-50____xJ5d {
  padding-right: 50px !important;
}

.RightSidebar-module__p-r-60___Cuc8O {
  padding-right: 60px !important;
}

.RightSidebar-module__m-b-1___aNq3w {
  margin-bottom: 1px !important;
}

.RightSidebar-module__m-b-2___f6BBz {
  margin-bottom: 2px !important;
}

.RightSidebar-module__m-b-6___S4oPH {
  margin-bottom: 6px !important;
}

.RightSidebar-module__m-b-8___rVskj {
  margin-bottom: 8px !important;
}

.RightSidebar-module__m-b-10___i9yOr {
  margin-bottom: 10px !important;
}

.RightSidebar-module__m-b-14___cml1d {
  margin-bottom: 14px !important;
}

.RightSidebar-module__m-b-16___hUNI0 {
  margin-bottom: 16px !important;
}

.RightSidebar-module__m-b-20___JmXHA {
  margin-bottom: 20px !important;
}

.RightSidebar-module__m-b-22___zN9Db {
  margin-bottom: 22px !important;
}

.RightSidebar-module__m-b-24___JN3V7 {
  margin-bottom: 24px !important;
}

.RightSidebar-module__m-b-30___q5gqz {
  margin-bottom: 30px !important;
}

.RightSidebar-module__m-b-32___uITKq {
  margin-bottom: 32px !important;
}

.RightSidebar-module__m-b-40___y1Yu1 {
  margin-bottom: 40px !important;
}

.RightSidebar-module__m-t-2___nODOd {
  margin-top: 2px !important;
}

.RightSidebar-module__m-t-3___i9ss7 {
  margin-top: 3px !important;
}

.RightSidebar-module__m-t-4___IKa8i {
  margin-top: 4px !important;
}

.RightSidebar-module__m-t-5___d_gS1 {
  margin-top: 5px !important;
}

.RightSidebar-module__m-t-8___z2P2d {
  margin-top: 8px !important;
}

.RightSidebar-module__m-t-10___K9Mhx {
  margin-top: 10px !important;
}

.RightSidebar-module__m-t-15___yZTu2 {
  margin-top: 15px !important;
}

.RightSidebar-module__m-t-16___jV3kc {
  margin-top: 16px !important;
}

.RightSidebar-module__m-t-20___NcLrt {
  margin-top: 20px !important;
}

.RightSidebar-module__m-t-22___pqJRK {
  margin-top: 22px !important;
}

.RightSidebar-module__m-t-30___qdUDS {
  margin-top: 30px !important;
}

.RightSidebar-module__m-t-32___aQgH8 {
  margin-top: 32px !important;
}

.RightSidebar-module__m-l-auto___TS3Ac {
  margin-left: auto !important;
}

.RightSidebar-module__m-l-4___Wcoyn {
  margin-left: 4px !important;
}

.RightSidebar-module__m-l-5___CMFie {
  margin-left: 5px !important;
}

.RightSidebar-module__m-l-6___bedUV {
  margin-left: 6px !important;
}

.RightSidebar-module__m-l-8___jw_He {
  margin-left: 8px !important;
}

.RightSidebar-module__m-l-10___lHEq4 {
  margin-left: 10px !important;
}

.RightSidebar-module__m-l-16___ayaG6 {
  margin-left: 16px !important;
}

.RightSidebar-module__m-l-20___jtvLi {
  margin-left: 20px !important;
}

.RightSidebar-module__m-l-24___rKV5x {
  margin-left: 24px !important;
}

.RightSidebar-module__m-l-30___bH8Bl {
  margin-left: 30px !important;
}

.RightSidebar-module__m-l-35___Bly9O {
  margin-left: 35px !important;
}

.RightSidebar-module__m-l-40___iYxCA {
  margin-left: 40px !important;
}

.RightSidebar-module__m-r-8___D1NEc {
  margin-right: 8px !important;
}

.RightSidebar-module__m-r-10___ikPnP {
  margin-right: 10px !important;
}

.RightSidebar-module__m-r-16___ka5aX {
  margin-right: 16px !important;
}

.RightSidebar-module__m-r-20___HojNH {
  margin-right: 20px !important;
}

.RightSidebar-module__m-r-24___T1YKs {
  margin-right: 24px !important;
}

.RightSidebar-module__m-r-30___uoaNn {
  margin-right: 30px !important;
}

.RightSidebar-module__m-r-40___YuLuV {
  margin-right: 40px !important;
}

.RightSidebar-module__border-r-3___QqMYf {
  border-radius: 3px !important;
}

.RightSidebar-module__border-r-4___NBcKD {
  border-radius: 4px !important;
}

.RightSidebar-module__border-r-6___fwv2k {
  border-radius: 6px !important;
}

.RightSidebar-module__border-r-10___x7fwE {
  border-radius: 10px !important;
}

.RightSidebar-module__border-r-12___x_ZEm {
  border-radius: 12px !important;
}

.RightSidebar-module__border-r-16___g73x1 {
  border-radius: 16px !important;
}

.RightSidebar-module__border-r-50___djosz {
  border-radius: 50% !important;
}

.RightSidebar-module__primary-border___cbv89 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.RightSidebar-module__primary-border-b___dfKfW {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.RightSidebar-module__primary-border-t___s6Z1X {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.RightSidebar-module__primary-border-l___JpnqY {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.RightSidebar-module__primary-border-r___WkSQk {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.RightSidebar-module__secondary-border___EMnaF {
  border: 1px solid #637768;
}

.RightSidebar-module__secondary-border-b___JorgV {
  border-bottom: 1px solid #637768;
}

.RightSidebar-module__secondary-border-t___vk_lk {
  border-top: 1px solid #637768;
}

.RightSidebar-module__secondary-border-l___fFBYA {
  border-left: 1px solid #637768;
}

.RightSidebar-module__secondary-border-r___FC1PE {
  border-right: 1px solid #637768;
}

.RightSidebar-module__gap-0___FMW1x {
  gap: 0 !important;
}

.RightSidebar-module__gap-2___k5SAP {
  gap: 2px !important;
}

.RightSidebar-module__gap-4___pw6NF {
  gap: 4px !important;
}

.RightSidebar-module__gap-5____0bIQ {
  gap: 5px !important;
}

.RightSidebar-module__gap-6___DdTXh {
  gap: 6px !important;
}

.RightSidebar-module__gap-8___n32yH {
  gap: 8px !important;
}

.RightSidebar-module__gap-10___v06ra {
  gap: 10px !important;
}

.RightSidebar-module__gap-12___JxeDD {
  gap: 12px !important;
}

.RightSidebar-module__gap-14___Z77XL {
  gap: 14px !important;
}

.RightSidebar-module__gap-16___COKIG {
  gap: 16px !important;
}

.RightSidebar-module__gap-18___So4Ar {
  gap: 18px !important;
}

.RightSidebar-module__gap-20___fwgDF {
  gap: 20px !important;
}

.RightSidebar-module__gap-24___jNCwC {
  gap: 24px !important;
}

.RightSidebar-module__gap-26___BKtTv {
  gap: 26px !important;
}

.RightSidebar-module__gap-30___Xex38 {
  gap: 30px !important;
}

.RightSidebar-module__gap-32___u932a {
  gap: 32px !important;
}

.RightSidebar-module__gap-40___RTZCM {
  gap: 40px !important;
}

.RightSidebar-module__gap-50___NPrnc {
  gap: 50px !important;
}

.RightSidebar-module__flex-1___XFssY {
  flex: 1;
}

.RightSidebar-module__flex-none___hawlc {
  flex: none !important;
}

.RightSidebar-module__flex-column___Ec4i0 {
  display: flex;
  flex-direction: column !important;
}

.RightSidebar-module__flex-row___MsECy {
  display: flex;
  flex-direction: row !important;
}

.RightSidebar-module__vertically-centered___O00bW {
  display: flex;
  align-items: center !important;
}

.RightSidebar-module__horizontally-centered___jzvI2 {
  display: flex;
  justify-content: center !important;
}

.RightSidebar-module__horizontally-end___e3AWh {
  display: flex;
  justify-content: end !important;
}

.RightSidebar-module__vertically-start___QcmR6 {
  display: flex;
  align-items: start !important;
}

.RightSidebar-module__space-between___sJy0Z {
  display: flex;
  justify-content: space-between !important;
}

.RightSidebar-module__flex-wrap___XBDka {
  flex-wrap: wrap !important;
}

.RightSidebar-module__height-100___FIwKI {
  height: 100%;
}

.RightSidebar-module__width-50___V0Sri {
  width: 50% !important;
}

.RightSidebar-module__width-100___RC5CE {
  width: 100%;
}

.RightSidebar-module__cursor-pointer___KGqbP {
  cursor: pointer;
}

.RightSidebar-module__cursor-not-allowed___Zg82f {
  cursor: not-allowed !important;
}

.RightSidebar-module__absolute-centered___R_Ewk {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.RightSidebar-module__absolute___AunZI {
  position: absolute;
}

.RightSidebar-module__relative___DaIof {
  position: relative;
}

.RightSidebar-module__fixed___tqkWL {
  position: fixed;
}

.RightSidebar-module__visible___cYrZ4 {
  opacity: 1;
}

.RightSidebar-module__invisible___Do7HE {
  opacity: 0;
}

.RightSidebar-module__col-90___hDvio {
  width: 90% !important;
}

.RightSidebar-module__col-auto___pM3aU {
  width: auto !important;
}

.RightSidebar-module__medical-tabs___OKaww {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.RightSidebar-module__medical-table-new___vcuIW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RightSidebar-module__medical-table-new___vcuIW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RightSidebar-module__medical-table-new___vcuIW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RightSidebar-module__medical-table-new___vcuIW::-webkit-scrollbar-track {
  display: none;
}
.RightSidebar-module__medical-table-new___vcuIW.RightSidebar-module__no-pagination___gLoh0 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.RightSidebar-module__medical-table-new___vcuIW.RightSidebar-module__no-pagination___gLoh0:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RightSidebar-module__medical-table-new___vcuIW.RightSidebar-module__no-pagination___gLoh0::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RightSidebar-module__medical-table-new___vcuIW.RightSidebar-module__no-pagination___gLoh0::-webkit-scrollbar-track {
  display: none;
}

.RightSidebar-module__medical-table-empty___qu7C7 {
  padding: 14px 40px !important;
}

.RightSidebar-module__icon-btn___nQwMQ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.RightSidebar-module__search-icon___IPQN3 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.RightSidebar-module__disable-select___R_I_6 {
  user-select: none;
}

.RightSidebar-module__break-word___S6r99 {
  word-break: break-word;
}

.RightSidebar-module__popup-clear-btn___SsGmh {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.RightSidebar-module__scroll-m-b-20___ZLU5p {
  scroll-margin-bottom: 20px;
}

.RightSidebar-module__aside___mqb06 {
  background: #fbf7f2;
  transition: margin-left 0.4s ease-in-out;
  box-sizing: border-box;
  min-width: 270px;
  width: 270px;
  margin-left: -270px;
  visibility: hidden;
  pointer-events: none;
}
.RightSidebar-module__aside___mqb06.RightSidebar-module__extended___f019I {
  margin-left: 0;
  visibility: visible;
  pointer-events: auto;
}
.RightSidebar-module__aside___mqb06 .RightSidebar-module__collapseButton___kdOvA {
  border-radius: 6px;
  width: auto;
  padding: 0;
}
.RightSidebar-module__aside___mqb06 .RightSidebar-module__header___F8e6B {
  color: #375844;
  margin: 0 18px;
  padding: 15px 0;
  justify-content: space-between;
}
.RightSidebar-module__aside___mqb06 .RightSidebar-module__header___F8e6B .RightSidebar-module__icon___MGs5P {
  width: 22px;
  height: 22px;
}
.RightSidebar-module__aside___mqb06 .RightSidebar-module__content___eFfuy {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer) - 60px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.RightSidebar-module__aside___mqb06 .RightSidebar-module__content___eFfuy:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.RightSidebar-module__aside___mqb06 .RightSidebar-module__content___eFfuy::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.RightSidebar-module__aside___mqb06 .RightSidebar-module__content___eFfuy::-webkit-scrollbar-track {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/base/RightSidebar/RightSidebar.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,mBAAA;EACA,wCAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AA8pBF;AA5pBE;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;AA8pBJ;AA3pBE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AA6pBJ;AA1pBE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;AA4pBJ;AA1pBI;EACE,WAAA;EACA,YAAA;AA4pBN;AAxpBE;EC1BA,kHD4BI;EC3BJ,kBAAA;EACA,kBAAA;ADqrBF;ACnrBE;EACE,oCAAA;EACA,mBAAA;ADqrBJ;AClrBE;EACE,UAAA;EACA,6BAAA;ADorBJ;ACjrBE;EACE,aAAA;ADmrBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.aside {\n  background: get-color(orangeNew, light);\n  transition: margin-left 0.4s ease-in-out;\n  box-sizing: border-box;\n  min-width: 270px;\n  width: 270px;\n  margin-left: -270px;\n  visibility: hidden;\n  pointer-events: none;\n\n  &.extended {\n    margin-left: 0;\n    visibility: visible;\n    pointer-events: auto;\n  }\n\n  .collapseButton {\n    border-radius: 6px;\n    width: auto;\n    padding: 0;\n  }\n\n  .header {\n    color: get-color(greenNew, dark);\n    margin: 0 18px;\n    padding: 15px 0;\n    justify-content: space-between;\n\n    .icon {\n      width: 22px;\n      height: 22px;\n    }\n  }\n\n  .content {\n    @include verticalScroll(\n      calc(\n        100vh - var(--top-navigation) - var(--patient-details-header) - var(\n            --patient-details-footer\n          ) -\n          60px\n      )\n    );\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `RightSidebar-module__font-s-10___DacaV`,
	"fontS12": `RightSidebar-module__font-s-12___EJu1q`,
	"fontS13": `RightSidebar-module__font-s-13___hgo1n`,
	"fontS14": `RightSidebar-module__font-s-14___qZdWi`,
	"fontS15": `RightSidebar-module__font-s-15___E4Vog`,
	"fontS16": `RightSidebar-module__font-s-16___zwikC`,
	"fontS18": `RightSidebar-module__font-s-18___EaQKp`,
	"fontS20": `RightSidebar-module__font-s-20___dwv6O`,
	"fontS22": `RightSidebar-module__font-s-22___fOIcl`,
	"fontS28": `RightSidebar-module__font-s-28___GI81Y`,
	"fontW400": `RightSidebar-module__font-w-400___c2Ybm`,
	"fontW500": `RightSidebar-module__font-w-500___aJLy2`,
	"fontW600": `RightSidebar-module__font-w-600___g9Rtq`,
	"fontW700": `RightSidebar-module__font-w-700___pIo6H`,
	"p5": `RightSidebar-module__p-5___yghRX`,
	"p12": `RightSidebar-module__p-12___FNMDL`,
	"p16": `RightSidebar-module__p-16___OM7FV`,
	"p30": `RightSidebar-module__p-30___JaZus`,
	"pB0": `RightSidebar-module__p-b-0___Gy96Y`,
	"pB5": `RightSidebar-module__p-b-5___qiRoI`,
	"pB10": `RightSidebar-module__p-b-10___UMEe1`,
	"pB12": `RightSidebar-module__p-b-12___zmPUL`,
	"pB16": `RightSidebar-module__p-b-16___btmLb`,
	"pB18": `RightSidebar-module__p-b-18___ToNjD`,
	"pB20": `RightSidebar-module__p-b-20___eLEgf`,
	"pB25": `RightSidebar-module__p-b-25___qMU4i`,
	"pB30": `RightSidebar-module__p-b-30___dUxkr`,
	"pB50": `RightSidebar-module__p-b-50___FhwTE`,
	"pT0": `RightSidebar-module__p-t-0___nWTke`,
	"pT12": `RightSidebar-module__p-t-12___w8ew5`,
	"pT16": `RightSidebar-module__p-t-16___bO9vh`,
	"pT18": `RightSidebar-module__p-t-18___s1Ies`,
	"pT20": `RightSidebar-module__p-t-20___nMFus`,
	"pT30": `RightSidebar-module__p-t-30___QuvuJ`,
	"pT40": `RightSidebar-module__p-t-40___pV5_a`,
	"pT50": `RightSidebar-module__p-t-50____HqPD`,
	"pL20": `RightSidebar-module__p-l-20___rIeXr`,
	"pL30": `RightSidebar-module__p-l-30___eD78m`,
	"pL40": `RightSidebar-module__p-l-40___nH7di`,
	"pR16": `RightSidebar-module__p-r-16___cvgy8`,
	"pR20": `RightSidebar-module__p-r-20___MMrN4`,
	"pR30": `RightSidebar-module__p-r-30___cxxB9`,
	"pR50": `RightSidebar-module__p-r-50____xJ5d`,
	"pR60": `RightSidebar-module__p-r-60___Cuc8O`,
	"mB1": `RightSidebar-module__m-b-1___aNq3w`,
	"mB2": `RightSidebar-module__m-b-2___f6BBz`,
	"mB6": `RightSidebar-module__m-b-6___S4oPH`,
	"mB8": `RightSidebar-module__m-b-8___rVskj`,
	"mB10": `RightSidebar-module__m-b-10___i9yOr`,
	"mB14": `RightSidebar-module__m-b-14___cml1d`,
	"mB16": `RightSidebar-module__m-b-16___hUNI0`,
	"mB20": `RightSidebar-module__m-b-20___JmXHA`,
	"mB22": `RightSidebar-module__m-b-22___zN9Db`,
	"mB24": `RightSidebar-module__m-b-24___JN3V7`,
	"mB30": `RightSidebar-module__m-b-30___q5gqz`,
	"mB32": `RightSidebar-module__m-b-32___uITKq`,
	"mB40": `RightSidebar-module__m-b-40___y1Yu1`,
	"mT2": `RightSidebar-module__m-t-2___nODOd`,
	"mT3": `RightSidebar-module__m-t-3___i9ss7`,
	"mT4": `RightSidebar-module__m-t-4___IKa8i`,
	"mT5": `RightSidebar-module__m-t-5___d_gS1`,
	"mT8": `RightSidebar-module__m-t-8___z2P2d`,
	"mT10": `RightSidebar-module__m-t-10___K9Mhx`,
	"mT15": `RightSidebar-module__m-t-15___yZTu2`,
	"mT16": `RightSidebar-module__m-t-16___jV3kc`,
	"mT20": `RightSidebar-module__m-t-20___NcLrt`,
	"mT22": `RightSidebar-module__m-t-22___pqJRK`,
	"mT30": `RightSidebar-module__m-t-30___qdUDS`,
	"mT32": `RightSidebar-module__m-t-32___aQgH8`,
	"mLAuto": `RightSidebar-module__m-l-auto___TS3Ac`,
	"mL4": `RightSidebar-module__m-l-4___Wcoyn`,
	"mL5": `RightSidebar-module__m-l-5___CMFie`,
	"mL6": `RightSidebar-module__m-l-6___bedUV`,
	"mL8": `RightSidebar-module__m-l-8___jw_He`,
	"mL10": `RightSidebar-module__m-l-10___lHEq4`,
	"mL16": `RightSidebar-module__m-l-16___ayaG6`,
	"mL20": `RightSidebar-module__m-l-20___jtvLi`,
	"mL24": `RightSidebar-module__m-l-24___rKV5x`,
	"mL30": `RightSidebar-module__m-l-30___bH8Bl`,
	"mL35": `RightSidebar-module__m-l-35___Bly9O`,
	"mL40": `RightSidebar-module__m-l-40___iYxCA`,
	"mR8": `RightSidebar-module__m-r-8___D1NEc`,
	"mR10": `RightSidebar-module__m-r-10___ikPnP`,
	"mR16": `RightSidebar-module__m-r-16___ka5aX`,
	"mR20": `RightSidebar-module__m-r-20___HojNH`,
	"mR24": `RightSidebar-module__m-r-24___T1YKs`,
	"mR30": `RightSidebar-module__m-r-30___uoaNn`,
	"mR40": `RightSidebar-module__m-r-40___YuLuV`,
	"borderR3": `RightSidebar-module__border-r-3___QqMYf`,
	"borderR4": `RightSidebar-module__border-r-4___NBcKD`,
	"borderR6": `RightSidebar-module__border-r-6___fwv2k`,
	"borderR10": `RightSidebar-module__border-r-10___x7fwE`,
	"borderR12": `RightSidebar-module__border-r-12___x_ZEm`,
	"borderR16": `RightSidebar-module__border-r-16___g73x1`,
	"borderR50": `RightSidebar-module__border-r-50___djosz`,
	"primaryBorder": `RightSidebar-module__primary-border___cbv89`,
	"primaryBorderB": `RightSidebar-module__primary-border-b___dfKfW`,
	"primaryBorderT": `RightSidebar-module__primary-border-t___s6Z1X`,
	"primaryBorderL": `RightSidebar-module__primary-border-l___JpnqY`,
	"primaryBorderR": `RightSidebar-module__primary-border-r___WkSQk`,
	"secondaryBorder": `RightSidebar-module__secondary-border___EMnaF`,
	"secondaryBorderB": `RightSidebar-module__secondary-border-b___JorgV`,
	"secondaryBorderT": `RightSidebar-module__secondary-border-t___vk_lk`,
	"secondaryBorderL": `RightSidebar-module__secondary-border-l___fFBYA`,
	"secondaryBorderR": `RightSidebar-module__secondary-border-r___FC1PE`,
	"gap0": `RightSidebar-module__gap-0___FMW1x`,
	"gap2": `RightSidebar-module__gap-2___k5SAP`,
	"gap4": `RightSidebar-module__gap-4___pw6NF`,
	"gap5": `RightSidebar-module__gap-5____0bIQ`,
	"gap6": `RightSidebar-module__gap-6___DdTXh`,
	"gap8": `RightSidebar-module__gap-8___n32yH`,
	"gap10": `RightSidebar-module__gap-10___v06ra`,
	"gap12": `RightSidebar-module__gap-12___JxeDD`,
	"gap14": `RightSidebar-module__gap-14___Z77XL`,
	"gap16": `RightSidebar-module__gap-16___COKIG`,
	"gap18": `RightSidebar-module__gap-18___So4Ar`,
	"gap20": `RightSidebar-module__gap-20___fwgDF`,
	"gap24": `RightSidebar-module__gap-24___jNCwC`,
	"gap26": `RightSidebar-module__gap-26___BKtTv`,
	"gap30": `RightSidebar-module__gap-30___Xex38`,
	"gap32": `RightSidebar-module__gap-32___u932a`,
	"gap40": `RightSidebar-module__gap-40___RTZCM`,
	"gap50": `RightSidebar-module__gap-50___NPrnc`,
	"flex1": `RightSidebar-module__flex-1___XFssY`,
	"flexNone": `RightSidebar-module__flex-none___hawlc`,
	"flexColumn": `RightSidebar-module__flex-column___Ec4i0`,
	"flexRow": `RightSidebar-module__flex-row___MsECy`,
	"verticallyCentered": `RightSidebar-module__vertically-centered___O00bW`,
	"horizontallyCentered": `RightSidebar-module__horizontally-centered___jzvI2`,
	"horizontallyEnd": `RightSidebar-module__horizontally-end___e3AWh`,
	"verticallyStart": `RightSidebar-module__vertically-start___QcmR6`,
	"spaceBetween": `RightSidebar-module__space-between___sJy0Z`,
	"flexWrap": `RightSidebar-module__flex-wrap___XBDka`,
	"height100": `RightSidebar-module__height-100___FIwKI`,
	"width50": `RightSidebar-module__width-50___V0Sri`,
	"width100": `RightSidebar-module__width-100___RC5CE`,
	"cursorPointer": `RightSidebar-module__cursor-pointer___KGqbP`,
	"cursorNotAllowed": `RightSidebar-module__cursor-not-allowed___Zg82f`,
	"absoluteCentered": `RightSidebar-module__absolute-centered___R_Ewk`,
	"absolute": `RightSidebar-module__absolute___AunZI`,
	"relative": `RightSidebar-module__relative___DaIof`,
	"fixed": `RightSidebar-module__fixed___tqkWL`,
	"visible": `RightSidebar-module__visible___cYrZ4`,
	"invisible": `RightSidebar-module__invisible___Do7HE`,
	"col90": `RightSidebar-module__col-90___hDvio`,
	"colAuto": `RightSidebar-module__col-auto___pM3aU`,
	"medicalTabs": `RightSidebar-module__medical-tabs___OKaww`,
	"medicalTableNew": `RightSidebar-module__medical-table-new___vcuIW`,
	"noPagination": `RightSidebar-module__no-pagination___gLoh0`,
	"medicalTableEmpty": `RightSidebar-module__medical-table-empty___qu7C7`,
	"iconBtn": `RightSidebar-module__icon-btn___nQwMQ`,
	"searchIcon": `RightSidebar-module__search-icon___IPQN3`,
	"disableSelect": `RightSidebar-module__disable-select___R_I_6`,
	"breakWord": `RightSidebar-module__break-word___S6r99`,
	"popupClearBtn": `RightSidebar-module__popup-clear-btn___SsGmh`,
	"scrollMB20": `RightSidebar-module__scroll-m-b-20___ZLU5p`,
	"aside": `RightSidebar-module__aside___mqb06`,
	"extended": `RightSidebar-module__extended___f019I`,
	"collapseButton": `RightSidebar-module__collapseButton___kdOvA`,
	"header": `RightSidebar-module__header___F8e6B`,
	"icon": `RightSidebar-module__icon___MGs5P`,
	"content": `RightSidebar-module__content___eFfuy`
};
module.exports = ___CSS_LOADER_EXPORT___;
